/* eslint-disable react/prop-types */
/* global Office, window, process */
import * as React from "react";
import { clearAccessDenied } from "../slices/authSlice";
import { useAppDispatch } from "../store";
import Microsoft from "./svg/Microsoft";
import GetAccessLink from "./Auth/GetAccessLink";
import { openSdaLoginDialog } from "./Auth/sdaLoginDialog";

function Login({ isOfficeInitialized }) {
  const dispatch = useAppDispatch();
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    dispatch(clearAccessDenied());
  }, [dispatch]);

  function handleSdaLogin() {
    setError("");
    openSdaLoginDialog(isOfficeInitialized, dispatch, setError);
  }

  return (
    <div className="sso-login-wrapper auth-screen">
      <div className="login-form">
        <p className="form-title">IQVIA Unity</p>
        {error ? (
          <p className="auth-inline-error" role="alert">
            {error}
          </p>
        ) : null}
        <button type="button" className="azure-login-button" onClick={handleSdaLogin}>
          <Microsoft width={20} height={20} />
          Log in with SSO
        </button>
        <GetAccessLink />
      </div>
    </div>
  );
}

export default Login;
